import { Button, Group, Popover, Text, UnstyledButton } from "@mantine/core";
import { useState } from "react";
import moment from "moment";
import { deleteMar, getMar } from "../../services";
import { IconTrash, IconRefresh } from "@tabler/icons-react";
import { LiaUndoAltSolid } from "react-icons/lia";
import useStyles from "./style";
import { FaUndo } from "react-icons/fa";
import { useSelector } from "react-redux";
import { getActiveSlotForDate } from "../../utils";

const DeleteComponent = ({ data, onClose, onclose, type }) => {
  // Resolve string status from medicationType (handles both old string and new array)
  const { classes } = useStyles();
  const { selectedClient } = useSelector((state) => state.mar);
  const resolveStatus = (mt) => {
    if (!mt) return "upcoming";
    if (typeof mt === "string") return mt;
    if (Array.isArray(mt) && mt.length > 0)
      return mt[mt.length - 1]?.status || "upcoming";
    return "upcoming";
  };
  const closeHandler = onClose || onclose;
  const [deleteModal, setDeleteModal] = useState(false);
  const [dltLoading, setDltLoading] = useState(false);

  const text = type === "prn" ? "Delete" : "Clear";

  const removeMedication = async () => {
    setDltLoading(true);
    // timeSlot MUST be included so the backend's delete() can scope the removal
    // to the exact slot being reset.  Without it, when a medication has multiple
    // time slots on the same date (e.g. 12:00 PM and 02:00 PM), the backend
    // previously matched by date alone and wiped ALL slots for that day.
    const timeSlot = getActiveSlotForDate(data?.timeSlot, data?.date);
    const obj = {
      client: data?.client?._id || data?.client?.id,
      marId: data?._id,
      // Convert UTC ISO string to local YYYY-MM-DD so the backend can match
      // the stored entry correctly.  The CREATE path sends getCalendarDateKey()
      // which formats in local timezone (e.g. "2024-03-15" for PKT UTC+5).
      // Sending the raw ISO string causes moment.utc() in the backend to
      // extract the PREVIOUS day for UTC+ users → entry not found → silent no-op.
      date: (() => {
        const rawDate =
          type === "prn"
            ? data?.administeredAt || data?.medicationType?.[0]?.date || data?.date
            : data?.date;
        return rawDate ? moment.utc(rawDate).format("YYYY-MM-DD") : rawDate;
      })(),
      timeSlot,
      type,
    };
    await deleteMar(obj);
    setDltLoading(false);
    setDeleteModal(false);
    const calendar_view = localStorage.getItem("calendar_date");
    getMar(calendar_view, selectedClient?.id);
    if (closeHandler) closeHandler();
  };
  return (
    <Popover
      opened={deleteModal}
      width={300}
      position="left-start"
      withArrow
      shadow="md"
    >
      <Popover.Target>
        {type === "scheduled" ? (
          <UnstyledButton
          className={classes.medRefreshBtn}
            onClick={() => {
              if (resolveStatus(data?.medicationType) !== "Missed") {
                setDeleteModal(true);
              }
            }}
          >
            <FaUndo />
            Clear
          </UnstyledButton>
        ) : (
          <UnstyledButton className={classes.prnMedDeleteBtn} onClick={() => setDeleteModal(true)}>
            <IconTrash />
            Delete
          </UnstyledButton>
        )}
      </Popover.Target>
      <Popover.Dropdown>
        <Text size="sm">Are you sure you want to {text}?</Text>

        <Group grow mt={10}>
          <Button
            onClick={() => setDeleteModal(false)}
            size={"xs"}
            color="yellow"
          >
            Cancel
          </Button>
          <Button
            loading={dltLoading}
            size={"xs"}
            color={"yellow"}
            onClick={removeMedication}
            disabled={
              resolveStatus(data?.medicationType) === "Missed" ? true : false
            }
          >
            {text}
          </Button>
        </Group>
      </Popover.Dropdown>
    </Popover>
  );
};

export default DeleteComponent;
